import React from 'react';
import CandidatoAvatar from '../../components/CandidatoAvatar';

export function VereadorLine({ vereador, children }) {
  return (
    <div className="meet-line meet-line--vereador">
      <CandidatoAvatar candidato={vereador} foto={vereador.foto} nome={vereador.nome} size={36} className="rounded-lg border border-white/10 shrink-0" />
      <div className="meet-line__bubble meet-line__bubble--vereador">{children}</div>
    </div>
  );
}

export function PlayerLine({ playerAvatar, children }) {
  return (
    <div className="meet-line meet-line--player">
      <div className="meet-line__bubble meet-line__bubble--player">{children}</div>
      <div className="meet-line__avatar shrink-0" dangerouslySetInnerHTML={{ __html: playerAvatar.svg }} />
    </div>
  );
}

export function VereadorTyping({ vereador }) {
  return (
    <div className="meet-line meet-line--vereador">
      <CandidatoAvatar candidato={vereador} foto={vereador.foto} nome={vereador.nome} size={36} className="rounded-lg border border-white/10 shrink-0" />
      <div className="meet-line__bubble meet-line__bubble--vereador meet-line__bubble--loading">
        <span className="meet-typing-dot" /><span className="meet-typing-dot" /><span className="meet-typing-dot" />
      </div>
    </div>
  );
}
